import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';

const PANEL_ID = 'poster-editor-nav-more-options-panel';

export default function PosterEditorNavMoreOptionsModal(): ReactElement<any> {
  const height = '474px';
  const maxWidth = '800px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_NAV_MORE_OPTIONS_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      modalMaxWidth={maxWidth}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="poster-editor-nav-more-options-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorNavMoreOptionsModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_NAV_MORE_OPTIONS_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
